<template>
  <div :class="{'is-active': showModal}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="modal-content-box">
        <div class="confirmation-title-bar">Add Note: {{businessName}}</div>

        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <label class="label">Note<span class="required">*</span></label>
            <div class="control">
              <textarea class="textarea" v-model="noteToAdd" rows="8" maxlength="500"
                        placeholder="Enter Note (Max 500 Characters)">
              </textarea>
            </div>
          </div>
          <div class="has-text-centered">
              <div class="xxlevel-item">
                <button :disabled="noteToAdd.length == 0" @click="onSave"
                  class="save-note-button button is-primary">
                  Save Note
                </button>
              </div>
              <p class="bail-out-message">
                <a href='#' @click="onCancel">Cancel</a>
              </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PaidPreparerData from '@/services/paid-preparer-data';

export default {
  name: 'AddUserNote',
  emits: ['saved', 'cancelled'],
  data() {
    return {
      noteToAdd: '',
      errorMessage: '',
    };
  },
  methods: {
    async onSave() {
      await PaidPreparerData.methods.addNote(this.userId, { note: this.noteToAdd });
      console.log('on save clicked');
      this.noteToAdd = '';
      this.$emit('saved');
    },
    onCancel() {
      console.log('on cancel clicked');
      this.noteToAdd = '';
      this.$emit('cancelled');
    },
  },
  computed: {},
  props: {
    userId: String,
    businessName: String,
    showModal: Boolean,
  },
};

</script>

<style scoped>
button {
  margin-top: 30px;
  min-width: 100%;
  border-radius: 8px;
}
.modal-background {
  opacity: 0.75;
}
.modal-content {
  max-width: 500px;
}
.modal-content-box {
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.21);
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.modal-content-wrapper {
  padding: 25px 25px;
}
.confirmation-title-bar {
  background-color: #FBBB00;
  color: #0F3D80;
  font-size: 18px;
  font-weight: bold;
  min-height: 30px;
  padding-left: 18px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.bail-out-message {
  margin-top: 15px;
}
.required {
  color: red;
  margin-left: 5px;
}

</style>
